const isPrescriptor = (values) => values.can_prescribe

export const ProfessionalValidation = (values, props) => {
  const { t } = props
  const errors = {}

  if (isPrescriptor(values)) {
    if (!values.firstname) {
      errors.firstname = t('Campo requerido')
    }
    if (!values.surname) {
      errors.surname = t('Campo requerido')
    }
    if (!values.lastname) {
      errors.lastname = t('Campo requerido')
    }
    if (!/^\d{8,9}$/.test(values.validated_collegiate_number)) {
      errors.validated_collegiate_number = t('incorrectCollegiate')
    }
  }

  if (!values.name) {
    errors.name = t('Campo requerido')
  }
  if (!values.phone) {
    errors.phone = t('Requerido')
  } else if (
    (values.phone.localPhone && !values.phone.localPhone) ||
    (values.phone.dialCode && values.phone.phone && values.phone.dialCode === values.phone.phone)
  ) {
    errors.phone = t('Requerido')
  }
  if (!values.email) {
    errors.email = t('Campo requerido')
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = t('Email invalido')
  }
  if (!values.avatar) {
    errors.avatar = t('Campo requerido')
  }
  if (!values.countries || values.countries.length === 0) {
    errors.countries = t('Campo requerido')
  }
  if (values.roles && !values.roles.length) {
    errors.roles = t('Campo requerido')
  }
  if (!values.app_role_id) {
    errors.app_role_id = t('Campo requerido')
  }
  if (!values.speciality) {
    errors.speciality = t('Campo requerido')
  }
  if (!values.timezone) {
    errors.timezone = t('Campo requerido')
  }
  if (!values.access_type) {
    errors.access_type = t('Campo requerido')
  }

  let translationsArrayErrors = []
  values.translations &&
    values.translations.forEach((translation, index) => {
      let translationErrors = {}

      if (!translation.language) {
        translationErrors = { ...translationErrors, language: t('Idioma requerido') }
        translationsArrayErrors[index] = translationErrors
      }
      if (!translation.title) {
        translationErrors = { ...translationErrors, title: t('Título requerido') }
        translationsArrayErrors[index] = translationErrors
      }
      if (!translation.overview) {
        translationErrors = { ...translationErrors, overview: t('Descripción requerido') }
        translationsArrayErrors[index] = translationErrors
      }
    })
  if (translationsArrayErrors.length) {
    errors.translations = {}
    errors.translations = translationsArrayErrors
  }
  for (const errorProperty in errors) {
    if (
      values.translations &&
      !values.translations.some((translation) => translation.language && translation.language.name === 'Español')
    ) {
      errors._error = { ...errors._error, spanishIsRequired: t('Es necesaria una traducción en español') }
    }
    if (errorProperty === 'translations') {
      errors._error = { ...errors._error, translationArray: t('Faltan campos para rellenar en las traducciones') }
    }
  }
  return errors
}
